import type { FeatureCollection } from "geojson";

const cache = new Map<string, FeatureCollection>();

export class GeometryLoadError extends Error {
  constructor(public readonly region: string, cause: unknown) {
    super(`failed to load geometry for region ${region}: ${String(cause)}`);
    this.name = "GeometryLoadError";
  }
}

export async function loadGeometry(region: string): Promise<FeatureCollection> {
  const cached = cache.get(region);
  if (cached) return cached;

  const url = `/data/da-${region}.geo.json`;
  let res: Response;
  try {
    res = await fetch(url);
  } catch (cause) {
    throw new GeometryLoadError(region, cause);
  }
  if (!res.ok) {
    throw new GeometryLoadError(region, `HTTP ${res.status}`);
  }
  const parsed = (await res.json()) as FeatureCollection;
  cache.set(region, parsed);
  return parsed;
}

export function clearGeometryCache(): void {
  cache.clear();
}
